export default __webpack_public_path__ + "static/media/template_pro__0001_26---MichealSoyza.3e58cf3f.png";